import React, { useRef, useState, useEffect } from "react";

import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "react-modal";
import SimpleMap from "../../../components/gmaps";

const CustomerForm = (props) => {
  // //console.log(props);
  const now = new Date();
  const frmRef = useRef({});
  const bankRef = useRef({});
  const [bankClose, setBankClose] = useState(false);
  const [bankDetails, setBankDetails] = useState([]);

  const [backImage, setBackImage] = useState(
    "https://img.freepik.com/premium-vector/anonymous-user-circle-icon-vector-illustration-flat-style-with-long-shadow_520826-1931.jpg?w=1060"
  );
  const [profileUrl, setprofileUrl] = useState();

  const addressRef = useRef({});
  const [addressDetails, setAddressDetails] = useState([]);
  const [close, setClose] = useState(false);

  const personRef = useRef({});
  const [personDetails, setPersonDetails] = useState([]);
  const [personclose, setPersonClose] = useState(false);

  const [latLongClose, setLatLongClose] = useState(false);

  const [entryLatLong, setEntryLatLong] = useState({
    lat: "",
    lng: "",
  });

  const [latLong, setlatLong] = useState({
    lat: "",
    lng: "",
  });

  const [latlongclose, setLatlongclose] = useState(false);

  const handleLatLong = () => {
    setLatlongclose(true);
  };
  const [attachmentUrl, setAttachmentUrl] = useState();
    const attachmentFolder=localStorage.getItem("attachmentFolder");

  const AttachmentUpload = (e) => {
    const picData = new FormData();
    const file = e.target.files[0];
    if (file) {
      picData && picData.append("fileUpload", file, file.name);
      fetch(
        `${
          process.env.REACT_APP_BASE_URL
        }/api/file/${attachmentFolder}/customerAttachment/${new Date().valueOf()}/${file.name}`,
        {
          method: "POST",
          body: picData,
        }
      )
        .then((res) => res.json())
        .then((data) => {
          setAttachmentUrl(data.url);
        })
        .catch((err) => console.error(err));
    }
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        // //console.log(lat, long);
        setEntryLatLong({ lat, lng });
        setlatLong({ lat, lng });
      },
      (error) => {
        console.error(error);
      }
    );
  }, []);

  const uploadProImage = (e) => {
    const picData = new FormData();
    const file = e.target.files[0];
    picData.append("fileUpload", file, file.name);
    fetch(
      `${
        process.env.REACT_APP_BASE_URL
      }/api/file/${attachmentFolder}/customerProfiles/${new Date().valueOf()}/${file.name}`,
      {
        method: "POST",
        body: picData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setBackImage(`${process.env.REACT_APP_FILE_URL}${data.url}`);
        setprofileUrl(data.url);
      })
      .catch((err) => console.error(err));
  };

  const [id, setId] = useState(0);
  const { sendRequest: getIds } = useHttp();

  useEffect(() => {
    getIds(
      {
        // url: `/api/workServiceOrder/?orgId=${localStorage.getItem("orgId")}`,

        url: `/api/customer/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log(data);

        const now = new Date();
        const temp = Math.round(now.getTime() / 1000);

        let id = 0;

        if (data.length > 0) {
          id = data[data.length - 1].customerId;
        }

        let newId = id + temp;

        setId(newId);
      }
    );
  }, [getIds]);

  const { sendRequest: postCustomer } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault(false);
    if (addressDetails.length === 0) {
      toast.warn("Please add at least one Address.");
      return;
    }
    if (personDetails.length === 0) {
      toast.warn("Please add at least one Contact Person.");
      return;
    }
    if (bankDetails.length === 0) {
      toast.warn("Please add at least one Bank Details.");
      return;
    }
    var data = "";
    if (props.update) {
      data = {
        createdBy: parseInt(localStorage.getItem("id")),
        customerDetails: {
          customerId: props.update.customerId,
          fieldExecutiveId: parseInt(localStorage.getItem("id")),
          name: frmRef.current.customer_name.value,
          idProof: frmRef.current.id_proof.value,
          fileProfile: profileUrl,
          urlProfile: profileUrl,
          fileAttachment: attachmentUrl,
          paymentTermsInDays: frmRef.current.payment_days.value,
          workContactNumber: frmRef.current.cust_org_contact.value,
          emailId: frmRef.current.customer_org_email.value,
          createdBy: parseInt(localStorage.getItem("id")),
          status: frmRef.current.status.value,
          orgId: parseInt(localStorage.getItem("orgId")),
          // status: 1,
          regionId: 2,
          createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
          entryTime: moment().format("HH:mm:ss"),
          entryLatLong,
          customerAddressDetails: addressDetails,
          bankDetails: bankDetails,
          contactPersonDetails: personDetails,
        },
      };
    } else {
      data = {
        createdBy: parseInt(localStorage.getItem("id")),
        customerDetails: [
          {
            customerId: Math.round(now.getTime() / 1000),
            fieldExecutiveId: parseInt(localStorage.getItem("id")),
            name: frmRef.current.customer_name.value,
            idProof: frmRef.current.id_proof.value,
            fileAttachment: attachmentUrl,
            paymentTermsInDays: frmRef.current.payment_days.value,
            workContactNumber: frmRef.current.cust_org_contact.value,
            emailId: frmRef.current.customer_org_email.value,
            createdBy: parseInt(localStorage.getItem("id")),
            status: frmRef.current.status.value,
            orgId: parseInt(localStorage.getItem("orgId")),
            // status: 1,
            regionId: 2,
            createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
            entryTime: moment().format("HH:mm:ss"),
            entryLatLong,
            customerAddressDetails: addressDetails,
            bankDetails: bankDetails,
            contactPersonDetails: personDetails,
          },
        ],
      };
    }

    //  //console.log(data);
    postCustomer(
      {
        url: "/api/customer/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success(
          `Customer ${props.update ? "Updated" : "Added"} successfully`
        );
        props.addForm(false);
      }
    );
  };

  useEffect(() => {
    //console.log(props.update);
    if (props.update) {
      // // customerId: props.update
      frmRef.current.customer_name.value = props.update.name;
      frmRef.current.customer_org_email.value = props.update.emailId;
      frmRef.current.cust_org_contact.value = props.update.workContactNumber;
      frmRef.current.status.value = props.update.status;
      frmRef.current.id_proof.value = props.update.idProof;
      frmRef.current.payment_days.value = props.update.paymentTermsInDays;
      setAttachmentUrl(props.update.fileAttachment);
      setAddressDetails(props.update.customerAddressDetails);
      setPersonDetails(props.update.contactPersonDetails);
      setBankDetails(props.update.bankDetails);
      setBackImage(
        `${process.env.REACT_APP_FILE_URL}${props.update.fileProfile}`
      );

      // // fileAttachment: attachmentUrl,
      // // paymentTermsInDays: frmRef.current.payment_days.value,
    }
  }, [props.update]);

  const submitAddress = (e) => {
    e.preventDefault();
    const addressType = addressRef.current.address_type.value;
    const address = addressRef.current.landmark.value;
    const landmark = addressRef.current.landmark.value;
    const city = addressRef.current.city.value;
    const state = addressRef.current.state.value;
    const zipcode = addressRef.current.zipcode.value;
    const country = addressRef.current.country.value;
    const latlong = latLong;
    if (
      !addressType ||
      !country ||
      !landmark ||
      !city ||
      !state ||
      !latlong ||
      !zipcode
    ) {
      toast.info("Please fill in all fields!");

      return;
    } else {
      setAddressDetails((x) => [
        ...x,
        {
          srno:
            addressDetails.length > 0
              ? addressDetails[addressDetails.length - 1].srno + 1
              : 1,
          customerAddressId: props.update
            ? ""
            : Math.round(now.getTime() / 1000),
          addressType: addressType,
          landmark: landmark,
          address: address,
          city: city,
          state: state,
          zipCode: zipcode,
          country: country,
          latLong: { latitude: latlong.lat, longitude: latlong.lng },
          orgId: parseInt(localStorage.getItem("orgId")),
          createdBy: parseInt(localStorage.getItem("id")),
          status: 1,
          createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
          entryTime: moment().format("HH:mm:ss"),
          entryLatLong,
        },
      ]);
    }
    addressRef.current.address_type.value = "";
    addressRef.current.landmark.value = "";
    addressRef.current.city.value = "";
    addressRef.current.state.value = "";
    addressRef.current.zipcode.value = "";
    addressRef.current.country.value = "";
    //console.log(addressDetails);
  };
  const handleDelete = (index, e) => {
    setAddressDetails(addressDetails.filter((v, i) => i !== index));
  };
  // bank details
  const submitBankDetails = (e) => {
    e.preventDefault();

    // Get the values from the textboxes
    const accountNumberValue = bankRef.current.account_number.value;
    const accountHolderNameValue = bankRef.current.acc_holder_name.value;
    const ifscCodeValue = bankRef.current.ifsc_code.value;

    // Clear the textboxes
    bankRef.current.account_number.value = "";
    bankRef.current.acc_holder_name.value = "";
    bankRef.current.ifsc_code.value = "";

    setBankDetails((x) => [
      ...x,
      {
        srno:
          bankDetails.length > 0
            ? bankDetails[bankDetails.length - 1].srno + 1
            : 1,
        customerBankId: props.update ? "" : Math.round(now.getTime() / 1000),
        accountNumber: accountNumberValue,
        accountHolderName: accountHolderNameValue,
        ifscCode: ifscCodeValue,
        orgId: parseInt(localStorage.getItem("orgId")),
        createdBy: parseInt(localStorage.getItem("id")),
        status: 1,
        createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
        entryTime: moment().format("HH:mm:ss"),
        entryLatLong,
      },
    ]);
  };
  const handleDeleteBank = (index, e) => {
    setBankDetails(bankDetails.filter((v, i) => i !== index));
  };

  // person details

  const submitPersonDetails = (e) => {
    e.preventDefault();

    // Get the values from the textboxes
    const nameValue = personRef.current.name.value;
    const designationValue = personRef.current.designation.value;
    const workContactNumberValue = personRef.current.work_contact_number.value;
    const whatsappNumberValue = personRef.current.whatsapp_number.value;
    const emailValue = personRef.current.email.value;

    // Clear the textboxes
    personRef.current.name.value = "";
    personRef.current.designation.value = "";
    personRef.current.work_contact_number.value = "";
    personRef.current.whatsapp_number.value = "";
    personRef.current.email.value = "";

    setPersonDetails((x) => [
      ...x,
      {
        srno:
          personDetails.length > 0
            ? personDetails[personDetails.length - 1].srno + 1
            : 1,
        customerContactPersonId: props.update
          ? ""
          : parseInt(Date.now() * Math.random()).toString(),
        name: nameValue,
        designation: designationValue,
        workContactNumber: workContactNumberValue,
        whatsappContactNumber: whatsappNumberValue,
        emailId: emailValue,

        orgId: parseInt(localStorage.getItem("orgId")),
        createdBy: parseInt(localStorage.getItem("id")),
        status: 1,
        createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
        entryTime: moment().format("HH:mm:ss"),
        entryLatLong,
      },
    ]);
  };
  const handleDeletePerson = (index, e) => {
    setPersonDetails(personDetails.filter((v, i) => i !== index));
  };

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "30%",
      borderRadius: "5px",
      maxWidth: "700px",
      maxHeight: "500px",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Customer Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3 text-center">
                      <div className="form-group mt-5">
                        <img
                          src={`${backImage}`}
                          className="user-image img-circle"
                          width="160"
                          height="160"
                          alt="User Image"
                        />

                        <div className="input-group">
                          <div className="custom-file">
                            <label style={{ cursor: "pointer" }}>
                              <input
                                type="file"
                                className="custom-file-input"
                                id="file"
                                accept="image/*"
                                onChange={uploadProImage}
                              />
                              Upload
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor={"customer_name"}>
                          {"Customer Name"}
                        </label>
                        <input
                          type={"text"}
                          id={"customer_name"}
                          required
                          ref={(el) => (frmRef.current["customer_name"] = el)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"cust_org_contact"}>
                          {"Contact Number"}
                        </label>
                        <input
                          type={"number"}
                          id={"cust_org_contact"}
                          required
                          ref={(el) =>
                            (frmRef.current["cust_org_contact"] = el)
                          }
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"cust_org_contact"}>
                          {"Attachment"}
                        </label>

                        <div className="custom-file">
                          <input
                            type="file"
                            className="custom-file-input"
                            id="file"
                            accept="image/*"
                            // value={attachmentUrl ||""}
                            onChange={AttachmentUpload}
                          />
                          <label
                            className="custom-file-label"
                            for="exampleInputFile"
                          >
                            {attachmentUrl
                              ? attachmentUrl.split("/")[3]
                              : "Choose file"}
                          </label>
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor={"contact_person_details"}>
                          {"Contact Person Details"}
                        </label>{" "}
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <button
                          type={"button"}
                          id={"contact_person_details"}
                          autoComplete="off"
                          ref={(el) =>
                            (frmRef.current["contact_person_details"] = el)
                          }
                          className="btn btn-sm btn-success"
                          onClick={() => {
                            personDetails &&
                              setPersonDetails((items) =>
                                items.filter((x) => x.isSave || x.customerId)
                              );
                            setPersonClose(true);
                          }}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                    {/* /.col */}
                    <div className="col-md-3">
                      <div className="form-group">
                        {" "}
                        <label htmlFor={"status"}>{"Status"}</label>
                        <select
                          id="status"
                          className="form-control"
                          ref={(el) => (frmRef.current["status"] = el)}
                          required
                        >
                          <option value="">Select</option>
                          <option value="1">Active</option>
                          <option value="0">InActive</option>
                        </select>
                      </div>

                      <div className="form-group">
                        {" "}
                        <label htmlFor={"payment_days"}>
                          {"Payment Terms in Days"}
                        </label>
                        <input
                          type={"number"}
                          id={"payment_days"}
                          required
                          ref={(el) => (frmRef.current["payment_days"] = el)}
                          className="form-control"
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor={"bank_details"}>{"Bank Details"}</label>
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <button
                          type={"button"}
                          className="btn btn-sm btn-success"
                          onClick={() => {
                            setBankClose(true);
                            bankDetails &&
                              setBankDetails((items) =>
                                items.filter((x) => x.isSave || x.customerId)
                              );
                          }}
                        >
                          Add{" "}
                        </button>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        {" "}
                        <label htmlFor={"customer_org_email"}>
                          {"Customer Email Id "}
                        </label>
                        <input
                          type={"email"}
                          id={"customer_org_email"}
                          required
                          ref={(el) =>
                            (frmRef.current["customer_org_email"] = el)
                          }
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        {" "}
                        <label htmlFor={"id_proof"}>{"ID Proof"}</label>
                        <select
                          id="id_proof"
                          className="form-control"
                          ref={(el) => (frmRef.current["id_proof"] = el)}
                        >
                          <option value="0">Select</option>
                          <option value="GSTN ID">GSTN ID</option>
                          <option value="PAN ID">PAN ID</option>
                          <option value="CIN  ID">CIN ID</option>
                          <option value="Other(input)">Other(input)</option>
                        </select>
                      </div>

                      <div className="form-group">
                        <label htmlFor={"address_details"}>
                          {"Address Details"}
                        </label>
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <button
                          type={"button"}
                          id={"address_details"}
                          className="btn btn-sm btn-success"
                          onClick={() => {
                            addressDetails &&
                              setAddressDetails((items) =>
                                items.filter((x) => x.isSave || x.customerId)
                              );
                            setClose(true);
                          }}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>

      {latlongclose && (
        <Modal isOpen={true} style={modalStyles}>
          <SimpleMap
            lat={latLong.lat}
            lng={latLong.lng}
            set={setlatLong}
            close={setLatlongclose}
          />
        </Modal>
      )}
      {/* address modal */}
      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Customer Address</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"address_type"}>{"Address Type"}</label>

                <select
                  id="address_type"
                  className="form-control"
                  ref={(el) => (addressRef.current["address_type"] = el)}
                >
                  <option value="">Select</option>
                  <option value="Registered">Registered</option>
                  <option value="Billing">Billing</option>
                  <option value="Shipping">Shipping</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor={"zipcode"}>Zip Code(Postal)</label>
                <input
                  type={"text"}
                  id={"zipcode"}
                  required
                  ref={(el) => (addressRef.current["zipcode"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"landmark"}>Address(landmark)</label>
                <input
                  type={"input"}
                  id={"landmark"}
                  required
                  ref={(el) => (addressRef.current["landmark"] = el)}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label htmlFor={"lat_long"}>Lat/Long</label>
                <br />
                <button
                  onClick={(e) => {
                    handleLatLong(e);
                  }}
                  className="btn btn-sm btn-success"
                >
                  Add
                </button>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"city"}>City</label>
                <input
                  type={"input"}
                  id={"city"}
                  required
                  ref={(el) => (addressRef.current["city"] = el)}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label htmlFor={"country"}>Country</label>
                <input
                  type={"text"}
                  id={"country"}
                  required
                  ref={(el) => (addressRef.current["country"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"state"}>State</label>
                <input
                  type={"input"}
                  id={"state"}
                  required
                  ref={(el) => (addressRef.current["state"] = el)}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={submitAddress}
                >
                  +
                </button>
              </div>
            </div>
          </div>

          <hr />
          <div className="flexRow">
            <table className="table table-bordered text-center table-sm">
              {" "}
              <thead>
                <tr className="tableheaderrowview">
                  <th>Sr. No</th>
                  <th>Address Type</th>
                  <th>Address(landmark)</th>
                  <th>City</th>
                  <th>State/Province/region</th>
                  <th>Zip Code</th>
                  <th>Country</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {addressDetails &&
                  addressDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.addressType}</td>
                        <td>{itm.address}</td>
                        <td>{itm.city}</td>
                        <td>{itm.state}</td>
                        <td>{itm.zipCode}</td>
                        <td>{itm.country}</td>

                        <td>
                          {" "}
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={(e) => handleDelete(i, e)}
                          >
                            delete
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div className="text-center">
            <button
              className="btn btn-primary"
              onClick={() => {
                addressDetails &&
                  addressDetails.map((x) => (x["isSave"] = true));

                setClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      {/* end address modal */}
      {/* bank modal start */}
      {bankClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Employee Bank Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setBankClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"account_number"}>Account Number</label>

                <input
                  type={"input"}
                  id={"account_number"}
                  required
                  ref={(el) => (bankRef.current["account_number"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"acc_holder_name"}>Acc Holder Name</label>

                <input
                  type={"input"}
                  id={"acc_holder_name"}
                  required
                  ref={(el) => (bankRef.current["acc_holder_name"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"ifsc_code"}>IFSC Code</label>

                <input
                  type={"input"}
                  id={"ifsc_code"}
                  required
                  ref={(el) => (bankRef.current["ifsc_code"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <br />
              <div className="form-group">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={submitBankDetails}
                >
                  +
                </button>
              </div>
            </div>
          </div>

          <hr />
          <div className="flexRow">
            <table className="table table-bordered text-center table-sm">
              <thead>
                <tr className="">
                  <th>Sr. No</th>
                  <th>Account Number</th>
                  <th>Account Holder Name</th>
                  <th>IFSC Code</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {bankDetails &&
                  bankDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.accountNumber}</td>
                        <td>{itm.accountHolderName}</td>
                        <td>{itm.ifscCode}</td>

                        <td>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={(e) => handleDeleteBank(i, e)}
                          >
                            delete
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <div className="text-center">
            <button
              type="submit"
              className="btn btn-sm btn-primary"
              onClick={() => {
                bankDetails && bankDetails.map((x) => (x["isSave"] = true));
                setBankClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      {/* bank modal end */}
      {/* person modal */}
      {personclose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Contact Person Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setPersonClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <form onSubmit={submitPersonDetails}>
            <div className="row">
              <div className="col-md-4">
                <label htmlFor={"name"}>{"Name"}</label>
                <input
                  type="text"
                  list="name"
                  className="form-control"
                  ref={(el) => (personRef.current["name"] = el)}
                  autoComplete="off"
                  required
                />
              </div>
              <div className="col-md-4">
                <label htmlFor={"designation"}>Designation</label>
                <input
                  type={"input"}
                  id={"designation"}
                  required
                  ref={(el) => (personRef.current["designation"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor={"work_contact_number"}>
                  Contact Number(work)
                </label>
                <input
                  type={"input"}
                  id={"work_contact_number"}
                  required
                  ref={(el) => (personRef.current["work_contact_number"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <label htmlFor={"whatsapp_number"}>whatsapp Number</label>
                <input
                  type={"input"}
                  id={"whatsapp_number"}
                  required
                  ref={(el) => (personRef.current["whatsapp_number"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor={"email"}>Email id</label>
                <input
                  type={"email"}
                  id={"email"}
                  required
                  ref={(el) => (personRef.current["email"] = el)}
                  className="form-control"
                />
              </div>

              <div className="col-md-1 my-4">
                &nbsp;{" "}
                <button className="btn btn-sm btn-primary" type="submit">
                  +
                </button>
              </div>
            </div>
          </form>

          <hr />
          <div className="row"></div>
          <table className="table table-bordered table-sm">
            {" "}
            <thead>
              <tr className="tableheaderrowview">
                <th>Sr. No</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Contact Number</th>
                <th>whatsapp Number</th>
                <th>Email id</th>

                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {personDetails &&
                personDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{itm.name}</td>
                      <td>{itm.designation}</td>
                      <td>{itm.workContactNumber}</td>
                      <td>{itm.whatsappContactNumber}</td>
                      <td>{itm.emailId}</td>

                      <td>
                        {" "}
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={(e) => handleDeletePerson(i, e)}
                        >
                          delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <div className="text-center">
            <br />
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                personDetails.map((x) => (x["isSave"] = true));
                setPersonClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      {/* end person modal */}
    </>
  );
};

export default CustomerForm;
